import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Skeleton from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Skeleton';
import useMobileLayout from 'Hooks/useMobileLayout';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    left: 0,
    top: 0,
    position: 'fixed',
    borderTopRightRadius: theme.radius.sm,
    borderBottomRightRadius: theme.radius.sm,
    height: '100vh',
    width: '80px',
    boxShadow: theme.shadows[4],
    backgroundColor: theme.palette.facet.backgroundGray,
    padding: theme.spacing(2),
    zIndex: 1200,
    overflow: 'auto',
  },
  item: {
    marginTop: theme.spacing(0.75),
    marginBottom: theme.spacing(2.75),
  },
});

const totalNavItems = 5;

const NavigationSkeleton = ({
  classes,
}) => {
  const isMobile = useMobileLayout();

  if (isMobile) {
    return <div />;
  }

  return (
    <div className={classes.root}>
      <div>
        <Skeleton variant={'circle'} width={48} height={48} />
        {
        [...Array(totalNavItems)].map((item, i) => (
          <Skeleton
            key={`${item}.${i}`} // eslint-disable-line react/no-array-index-key
            className={classes.item}
            variant={'circle'}
            width={48}
            height={48}
          />
        ))
      }
      </div>
    </div>
  );
};

NavigationSkeleton.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(NavigationSkeleton);
